angular
    .module('eficienciaFiscalModule')
    .directive('ngIncludeTemplate', () => {
        return {
            templateUrl: (_elem, attrs) => attrs.ngIncludeTemplate,
            restrict: 'A',
            scope: {
                'tabData': '=ngIncludeVariables'
            }
        };
    })